<template>
  <div
    role="button"
    class="w-full px-4 py-2.5 mb-3 duration-200 rounded-lg bg-surface-0 dark:bg-surface-700"
  >
    <div class="truncate font-medium text-sm">
      <p class="font-semibold truncate">
        <Skeletor class="h-3 w-32" />
      </p>
      <p class="truncate">
        <Skeletor class="h-3 w-10/12" />
      </p>
      <span class="text-xs">
        <Skeletor class="h-2 w-24" />
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Skeletor } from "vue-skeletor";
</script>
